import { render, staticRenderFns } from "./userInfor.vue?vue&type=template&id=5037f6db&scoped=true"
import script from "./userInfor.vue?vue&type=script&lang=js"
export * from "./userInfor.vue?vue&type=script&lang=js"
import style0 from "./userInfor.vue?vue&type=style&index=0&id=5037f6db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037f6db",
  null
  
)

export default component.exports